/* eslint max-len: 0 */
import { defineMessages } from 'react-intl'
import {
  SHORT,
  LONG,
  KILOMETERS,
  MILES,
  FEET,
  YARDS,
  METERS,
  JOULES,
  KILOCALORIES,
  KILOJOULES,
  SECONDS,
  MINUTES,
  HOURS,
  DAYS,
  WEEKS,
  MONTHS,
  YEARS,
  FEET_PER_SECOND,
  MILES_PER_HOUR,
  KILOMETERS_PER_HOUR,
  METERS_PER_SECOND,
  KNOTS,
  HEART_RATE,
  MINUTE_KM,
  MINUTE_MI,
} from './constants'

export default defineMessages({

  // Distance
  // ==========================================================================
  [FEET + SHORT]: {
    id: 'units.ft',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>ft</span>',
  },
  [FEET + LONG]: {
    id: 'units.feet',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {foot} other {feet}}</span>',
  },
  [YARDS + SHORT]: {
    id: 'units.y',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>y</span>',
  },
  [YARDS + LONG]: {
    id: 'units.yards',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {yard} other {yards}}</span>',
  },
  [METERS + SHORT]: {
    id: 'units.m',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>m</span>',
  },
  [METERS + LONG]: {
    id: 'units.meters',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {meter} other {meters}}</span>',
  },
  [KILOMETERS + SHORT]: {
    id: 'units.km',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>km</span>',
  },
  [KILOMETERS + LONG]: {
    id: 'units.kilometer',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {kilometer} other {kilometers}}</span>',
  },
  [MILES + SHORT]: {
    id: 'units.mi',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>mi</span>',
  },
  [MILES + LONG]: {
    id: 'units.mile',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {mile} other {miles}}</span>',
  },

  // Energy
  // ==========================================================================
  [KILOCALORIES + SHORT]: {
    id: 'units.kcal',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>kcal</span>',
  },
  [KILOCALORIES + LONG]: {
    id: 'units.kilocalories',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {kilocalorie} other {kilocalories}}</span>',
  },
  [KILOJOULES + SHORT]: {
    id: 'units.kj',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>kJ</span>',
  },
  [KILOJOULES + LONG]: {
    id: 'units.kilojoules',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {kilojoule} other {kilojoules}}</span>',
  },
  [JOULES + SHORT]: {
    id: 'units.j',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>J</span>',
  },
  [JOULES + LONG]: {
    id: 'units.joules',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {joule} other {joules}}</span>',
  },

  // Duration
  // ==========================================================================
  [SECONDS + SHORT]: {
    id: 'units.s',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>s</span>',
  },
  [SECONDS + LONG]: {
    id: 'units.seconds',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {second} other {seconds}}</span>',
  },
  [MINUTES + SHORT]: {
    id: 'units.min',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>m</span>',
  },
  [MINUTES + LONG]: {
    id: 'units.minutes',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {minute} other {minutes}}</span>',
  },
  [HOURS + SHORT]: {
    id: 'units.h',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>h</span>',
  },
  [HOURS + LONG]: {
    id: 'units.hours',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {hour} other {hours}}</span>',
  },
  [DAYS + SHORT]: {
    id: 'units.d',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>d</span>',
  },
  [DAYS + LONG]: {
    id: 'units.days',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {day} other {days}}</span>',
  },
  [WEEKS + SHORT]: {
    id: 'units.wk',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>wk</span>',
  },
  [WEEKS + LONG]: {
    id: 'units.weeks',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {week} other {weeks}}</span>',
  },
  [MONTHS + SHORT]: {
    id: 'units.mo',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>mo</span>',
  },
  [MONTHS + LONG]: {
    id: 'units.months',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {month} other {months}}</span>',
  },
  [YEARS + SHORT]: {
    id: 'units.yr',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>yr</span>',
  },
  [YEARS + LONG]: {
    id: 'units.years',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {year} other {years}}</span>',
  },

  // Speed
  // ==========================================================================
  [FEET_PER_SECOND + SHORT]: {
    id: 'units.fps',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>ft/s</span>',
  },
  [FEET_PER_SECOND + LONG]: {
    id: 'units.feet_per_second',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {foot per second} other {feet per second}}</span>',
  },
  [MILES_PER_HOUR + SHORT]: {
    id: 'units.mph',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>mph</span>',
  },
  [MILES_PER_HOUR + LONG]: {
    id: 'units.miles_per_hour',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {mile per hour} other {miles per hour}}</span>',
  },
  [KILOMETERS_PER_HOUR + SHORT]: {
    id: 'units.kph',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>km/h</span>',
  },
  [KILOMETERS_PER_HOUR + LONG]: {
    id: 'units.kilometers_per_hour',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {kilometer per hour} other {kilometers per hour}}</span>',
  },
  [METERS_PER_SECOND + SHORT]: {
    id: 'units.mps',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>m/s</span>',
  },
  [METERS_PER_SECOND + LONG]: {
    id: 'units.meters_per_second',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {meter per second} other {meters per second}}</span>',
  },
  [KNOTS + SHORT]: {
    id: 'units.kn',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>kn</span>',
  },
  [KNOTS + LONG]: {
    id: 'units.knots',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {knot} other {knots}}</span>',
  },

  // Heart rate
  // ==========================================================================
  [HEART_RATE + SHORT]: {
    id: 'units.bpm',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>bpm</span>',
  },
  [HEART_RATE + LONG]: {
    id: 'units.heartrate',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {beat per minute} other {beats per minute}}</span>',
  },

  // Pace
  // ==========================================================================
  [MINUTE_KM + SHORT]: {
    id: 'units.mkm',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>min/km</span>',
  },
  [MINUTE_KM + LONG]: {
    id: 'units.minute_km',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {minute per kilometer} other {minute per kilometer}}</span>',
  },
  [MINUTE_MI + SHORT]: {
    id: 'units.mmi',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>min/mi</span>',
  },
  [MINUTE_MI + LONG]: {
    id: 'units.minute_mi',
    defaultMessage: '<span data-value>{formattedValue}</span> <span data-unit>{convertedValue, plural, one {minute per mile} other {minute per mile}}</span>',
  },

})



// WEBPACK FOOTER //
// ./src/shared/units/messages.js